/*
 * Web paths for the AI Ebook Builder (docs/ebook-builder/CONTRACTS.md: the
 * Course Builder's "Web routes" with /courses → /ebooks and lessons →
 * chapters). Every link in the feature is built here so a route change is one
 * edit, and so nothing interpolates an unchecked id into a path.
 *
 * The id and path checks are the Course Builder's own (imported, not copied).
 */
import { ULID_RE, isUlid, safeAppPath } from '../courseBuilder/paths';

export { ULID_RE, isUlid, safeAppPath };

/* Slugs the cloud will never hand out, because they are route segments
 * ('ai' was the old prefix, /ebooks/ai/…, and still redirects). */
export const RESERVED_SLUGS = ['ai', 'new', 's', 'build', 'edit', 'chapters', 'admin', 'mine', 'community', 'shared', 'setup', 'sitemap.xml', 'llms.txt'];

/* The /ebooks hub: Community (default) · My Ebooks · Shared with me. */
export const HUB_TABS = ['community', 'mine', 'shared'];

/* An ebook slug as the cloud makes them: lowercase words joined by hyphens. */
export function isEbookSlug(v) {
  return typeof v === 'string'
    && /^[a-z0-9](?:[a-z0-9-]{0,118}[a-z0-9])?$/.test(v)
    && !RESERVED_SLUGS.includes(v)
    && !isUlid(v.toUpperCase());
}

const seg = (v) => encodeURIComponent(String(v ?? ''));

export const paths = {
  hub: (tab) => (tab && HUB_TABS.includes(tab) ? `/ebooks?tab=${tab}` : '/ebooks'),
  mine: () => '/ebooks?tab=mine',
  newEbook: () => '/ebooks/new',
  ebook: (idOrSlug) => `/ebooks/${seg(idOrSlug)}`,
  chapter: (idOrSlug, chapterId) => `/ebooks/${seg(idOrSlug)}/chapters/${seg(chapterId)}`,
  build: (ebookId) => `/ebooks/${seg(ebookId)}/build`,
  edit: (ebookId, tab) => `/ebooks/${seg(ebookId)}/edit${tab ? `?tab=${seg(tab)}` : ''}`,
  link: (token) => `/ebooks/s/${seg(token)}`,
  linkChapter: (token, chapterId) => `/ebooks/s/${seg(token)}/chapters/${seg(chapterId)}`,
};

/* The link builder for "in this ebook" pages, for both id and link modes. */
export function ebookPaths({ ebookKey, token }) {
  if (token) {
    return {
      overview: () => paths.link(token),
      chapter: (chid) => paths.linkChapter(token, chid),
    };
  }
  return {
    overview: () => paths.ebook(ebookKey),
    chapter: (chid) => paths.chapter(ebookKey, chid),
  };
}
